import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { AppConstants } from '../constants/constants';
import { ICreditProjectPreference, IUserPeferences } from '../model/key-team-members-model';
@Injectable({
    providedIn: 'root',
})
export class KeyTeamMembersService {
    constructor(private http: HttpClient, private appConstants: AppConstants) { }

   /**
    * Save the credit project preference
    * @param ICreditProjectPreference - payload.
    */
   saveCreditProjectPreference(payload: ICreditProjectPreference): Observable<string> {
        const options: object = {responseType: 'text'};
        return this.http.put<string>(`${this.appConstants.API_BASE_URL_USER}/Preferences/CreditProject`, payload, options)
                .pipe(catchError((error: HttpErrorResponse) => throwError(error)))
   }

   /**
    * Fetch user peferences details
    * @param userId - user id
    * @returns IUserPeferences - returns user peferences model
    */
  fetchUserPeferences(userId: string): Observable<IUserPeferences> {
    const options = new HttpParams().set('userId', userId);
    return this.http.get<IUserPeferences>(`${this.appConstants.API_BASE_URL_USER}/Preferences/CreditProject`, { params: options });
  }
}
